<template>
  <OnboardingQuestion :title="question" :disabled="!answer" @next="handleClick">
    <SelectOption v-model="answer" :icon="BellIcon" value="Real-time alerts">
      Real-time alerts
    </SelectOption>
    <SelectOption v-model="answer" :icon="BellIcon" value="Periodic summaries">
      Periodic summaries
    </SelectOption>
    <SelectOption v-model="answer" :icon="BellIcon" value="I’d find out eventually">
      I’d find out eventually
    </SelectOption>
  </OnboardingQuestion>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { BellIcon } from '@dacr/icons'

import OnboardingQuestion from '@/features/onboarding/components/OnboardingQuestion.vue'
import SelectOption from '@/shared/components/SelectOption.vue'
import { useCompleteStepMutation } from '@/shared/graphql/legacy/generated'
import { OnboardingStep, useOnboardingStore } from '@/features/onboarding/store'

const { mutate: completeStep } = useCompleteStepMutation()

const onboardingStore = useOnboardingStore()

const question = 'How would you want to know about unauthorized use of your work?'

const answer = computed({
  get() {
    return (onboardingStore.state[OnboardingStep.Seven] || '') as string
  },
  set(value: string) {
    onboardingStore.state[OnboardingStep.Seven] = value
  },
})

const handleClick = () => {
  const answers = [answer.value]

  completeStep({ step: 7, question, answers })

  onboardingStore.goToNextStep({ question, answers })
}
</script>
